import React, { useCallback } from 'react';

import { IFormItemChangeValue } from '../../../../types/form-type';

interface IProps {
  id: string;
  labelId: string;
  value?: string,
  onChange: (value: IFormItemChangeValue) => void;
}

const Input: React.FC<IProps> = ({ id, value, onChange }) => {
  const handleChange = useCallback((event: React.ChangeEvent<HTMLInputElement>) => {
    const value = event.target.value;
    onChange({ [id]: value });
  }, [onChange, id])
  return (
    <input value={value || ''} onChange={handleChange} />
  )
}

export default Input
